export enum UserManualTypes {
    Student = 'STUDENT',
    Supervision = 'SUPERVISION',
    Lector = 'LECTOR'
}

export type UserManualType = `${UserManualTypes}`

export type UserManualLastChangeType = {
    name: undefined;
    surname: undefined;
    updatedAt: string;
    userId: undefined;
} | {
    name: string;
    surname: string;
    updatedAt: string;
    userId: number;
}